import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import { de } from './translations/de'
// import detector from "i18next-browser-languagedetector"
import { en } from './translations/en'
import { es } from './translations/es'
import { fi } from './translations/fi'
import { fr } from './translations/fr'
import { pl } from './translations/pl'
import { sct } from './translations/sct'

i18n
    // .use(detector)
    .use(initReactI18next)
    .init({
        resources: {
            en: { translation: en },
            de: { translation: de },
            fr: { translation: fr },
            es: { translation: es },
            pl: { translation: pl },
            fi: { translation: fi },
            sct: { translation: sct }
        },
        lng: 'en', // don't use if using a language detector
        fallbackLng: 'en',
        interpolation: {
            escapeValue: false
        }
    })
